import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Container,
  Text,
  Paper,
  Group,
  Button,
  Stack,
  PasswordInput,
} from "@mantine/core";
import { changePassword } from "./authApi";
import { useTranslation } from "react-i18next";
import LangSelector from "./LangSelector";
import { notifications } from "@mantine/notifications";
import { useLocation } from "wouter";

export default function ChangePassword() {
  const [isFetching, setIsFetching] = useState(false);
  const { t } = useTranslation("Auth");
  const [, setLocation] = useLocation();

  const form = useForm({
    initialValues: {
      emailAddress: "",
    },
    validate: {
      newPassword: (val) => (/^.{8}/.test(val) ? null : t("invalid_password")),
    },
  });

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder>
        <Group align="flex-start" justify="space-between">
          <Text size="lg" mb="xl" fw={500}>
            {t("change_password")}
          </Text>
          <LangSelector />
        </Group>

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            changePassword({ ...values })
              .then(() => {
                notifications.show({ title: "Password changed!" });
                setLocation("/profile");
              })
              .catch((err) => {
                notifications.show({
                  title: "An error occurred!",
                  message: "" + err,
                });
              })
              .finally(() => {
                setIsFetching(false);
              });
          })}
        >
          <Stack>
            <PasswordInput
              required
              label={t("current_password")}
              disabled={isFetching}
              {...form.getInputProps("currentPassword")}
              radius="md"
            />

            <PasswordInput
              required
              label={t("new_password")}
              disabled={isFetching}
              {...form.getInputProps("newPassword")}
              radius="md"
            />

            <Button loading={isFetching} type="submit" radius="xl">
              {t("change_password")}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
